import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { lightenColor } from '@/helpers/functions/theme';
import type { I_ProgramPreviewCardProps } from '@/types/ProgramPreviewCards';

export const ProgramPreviewCards = ({ programs }: I_ProgramPreviewCardProps) => {
  const { theme } = useWidgetConfig();
  const lighterBackground = lightenColor(theme?.bodyColor ?? '#FFF7ED', 90);
  return (
    <div className='space-y-3'>
      {programs.map(
        ({ title, description, icon, isShown }) =>
          isShown && (
            <div
              key={title}
              className={`mt-4 rounded-lg border p-4`}
              style={{ backgroundColor: lighterBackground, borderColor: lighterBackground }}
            >
              <div className='flex items-center space-x-3'>
                <div className='mt-0.5 flex-shrink-0'>{icon}</div>
                <div>
                  <h4 className='mb-1'>{title}</h4>
                  <h6 className='opacity-90'>{description}</h6>
                </div>
              </div>
            </div>
          ),
      )}
    </div>
  );
};
